module.exports = __webpack_public_path__ + "assets/category_type-0a581c.svg";